import { FileUploadState } from 'common/models/data/fileUpload.model';

const initialFileUploadState: FileUploadState = {
    isVisible: false,
    selectedFiles: [],
    uploadingFiles: [],
    uploadResponse: {},
    syncDetails: {},
    uploadFileDetails: {}
};

export default initialFileUploadState;
